import { render, staticRenderFns } from "./DashBoardDataUsage.vue?vue&type=template&id=2dc8de8c&scoped=true&"
import script from "./DashBoardDataUsage.vue?vue&type=script&lang=js&"
export * from "./DashBoardDataUsage.vue?vue&type=script&lang=js&"
import style0 from "./DashBoardDataUsage.vue?vue&type=style&index=0&id=2dc8de8c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2dc8de8c",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VAlert } from 'vuetify/lib/components/VAlert';
import { VCardText } from 'vuetify/lib/components/VCard';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VSheet } from 'vuetify/lib/components/VSheet';
import { VSparkline } from 'vuetify/lib/components/VSparkline';
installComponents(component, {VAlert,VCardText,VIcon,VSheet,VSparkline})
